module.exports = __webpack_public_path__ + "static/img/S325-PF_A.f04e0c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/S325-PF_A.jpg
// module id = aS3i
// module chunks = 0